module.exports = __webpack_public_path__ + "media/images/about/04-1e80df09a154a99f374e4547e3b4db07.jpg";